import { http } from '@/utils/http.js';
import { orgPath } from '@/utils/paths.js';

export const OrgsDashboardApi = {
  index() {
    return http.get(`${orgPath()}/dashboard`).then((response) => response.data.data);
  },
};
